/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

import { switchMap, first } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { fromPaymentActions, paymentQuery, PaymentState } from '../../+state/table';

/**
 * Gets PaymentHistory for payment-screen
 */
@Injectable()
export class PaymentHistoryResolver {
  constructor(private _store: Store<PaymentState>) {}

  /*
   * Resolve PaymentHistory
   * 1. Selects getPaymentHistory from the store
   * 3. Check if PaymentHistory is present
   * - If state is empty:
   *   1. Call getPaymentHistory
   * 4. Return paymentHistory from store.
   */
  public resolve(): Observable<any> {
    return this._store.select(paymentQuery.getPaymentHistory).pipe(
      switchMap(paymentHistory => {
        // TODO
        // for now we cannot use cached data
        // there is no delta sync/realtime infrastructure
        this.getPaymentHistory();
        return of(paymentHistory);

        // if (!paymentHistory) {
        //   this.getPaymentHistory();
        // }
        // return of(paymentHistory);
      }),
      first()
    );
  }

  /*
   * trigger fetching PaymentHistory
   * 1. Dispatch getPaymentHistory action
   */
  private getPaymentHistory() {
    this._store.dispatch(fromPaymentActions.getPaymentHistory());
  }
}
